import { PropsWithChildren } from 'react';
import { StyledOutletFooter } from './styled';

export function OutletFooter({ children }: PropsWithChildren): JSX.Element {
  return <StyledOutletFooter>{children}</StyledOutletFooter>;
}
